import { FC, useEffect, useState } from 'react'

import { IconArrowDown } from '@pijma/icon-gallery/crypto'

import { useToken } from '@hooks'
import styled from 'styled-components'

import { CaptionText500 } from '../../text/BodyText'
import { TextProps } from '../../text/TextProps'
import { TextSpan } from '../../text/TextSpan'
import { InfoSearchData } from './InfoSearchData'
import Modal from './Modal'

const ModalSelectInputWrapper = styled.div`
  position: relative;
`

const ModalSelectInputElement = styled.div`
  box-sizing: border-box;
  border: 1px solid rgb(217, 217, 217);
  border-radius: 16px;
  display: flex;
  -webkit-box-align: center;
  vertical-align: middle;
  align-items: center;
  -webkit-box-pack: justify;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
  cursor: pointer;
  background-color: white;

  :hover {
    background-color: aliceblue;
  }
`

const SelectedElementWrapper = styled.div`
  display: flex;
  align-items: center;
  height: auto;
  flex-direction: row;
`

const SelectedImg = styled.img`
  margin-right: 10px;
`

const ArrowWrapper = styled.div`
  line-height: 24px;
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: normal;
`

const Caption: FC<TextProps> = (props: TextProps) => (
  <TextSpan {...useToken().text.caption['500'].value} lineHeight={'20px'}>
    {props.children}
  </TextSpan>
)

interface ModalSelectInputProps {
  defaultIcon: string
  defaultText: string
  data: InfoSearchData[]
  searchTitle: string
  searchPlaceholder: string | undefined
  isSearchInputEnabled?: boolean
  onSelect: (id: string) => void
  selected: string | undefined
  label?: string | undefined
}

export const ModalSelectInput = ({
  defaultIcon,
  defaultText,
  data,
  searchTitle,
  searchPlaceholder,
  onSelect,
  isSearchInputEnabled,
  selected,
  label,
}: ModalSelectInputProps) => {
  const [selectedId, setSelectedId] = useState(selected)
  const [text, setText] = useState<string>(defaultText)
  const [icon, setIcon] = useState<string>(defaultIcon)
  const [isOpenModal, setOpenModal] = useState<boolean>(false)

  const onSearchElementSelect = (selected: InfoSearchData) => {
    onSelect(selected.id)
    setSelectedId(selected.id)
    setText(selected.name)
    if (selected.logo) {
      setIcon(selected.logo as string)
    } else {
      setIcon(defaultIcon)
    }
    setOpenModal(false)
  }

  const openModal = () => {
    setOpenModal(true)
  }

  const closeModal = () => {
    setOpenModal(false)
  }

  const tokens = useToken()

  useEffect(() => {
    if (selectedId && data) {
      const preSelected = data.find((item) => item.id == selectedId)
      if (preSelected) {
        setText(preSelected.name)
        if (preSelected.logo) {
          setIcon(preSelected.logo as string)
        } else {
          setIcon(defaultIcon)
        }
      }
    }
  }, [selectedId, selected, data])

  return (
    <ModalSelectInputWrapper>
      <ModalSelectInputElement onClick={openModal}>
        <SelectedElementWrapper>
          <SelectedImg src={icon} width={44} height={44} />
          <TextWrapper>
            <CaptionText500
              color={tokens.color.font.light_bg.label.default.value}
            >
              {label}
            </CaptionText500>
            <Caption>{text}</Caption>
          </TextWrapper>
        </SelectedElementWrapper>
        <ArrowWrapper>
          <IconArrowDown width={24} height={24} color={'#868686'} />
        </ArrowWrapper>
      </ModalSelectInputElement>
      <Modal
        isOpen={isOpenModal}
        closeModal={closeModal}
        searchPlaceholder={searchPlaceholder}
        searchTitle={searchTitle}
        isSearchInputEnabled={isSearchInputEnabled ?? true}
        onSearchElementSelect={onSearchElementSelect}
        data={data}
      />
    </ModalSelectInputWrapper>
  )
}
